import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import { Chips } from '../../../ui/Chips';
import { chipsStyles, FiltersOptionsWrapper } from './styled';
import { FiltersSection } from './FiltersSection';

export const NewSearchOnlyResidences = () => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();

  return (
    <FiltersSection title={t('search.form.seller')}>
      <FiltersOptionsWrapper>
        <Chips
          text={t('search.form.only_residences')}
          value={true}
          type="button"
          hasCustomOnChange
          storedValue={values.only_residences}
          onClick={() => change('only_residences', !values.only_residences)}
          styles={chipsStyles}
        />
      </FiltersOptionsWrapper>
    </FiltersSection>
  );
};
